<template>
	<select
		:class="['inp', { w100p: justify, inp_error: error, is_empty: !localValue }]"
		v-bind="attrs"
		v-model="localValue"
		v-on="listeners"
	>
		<option v-if="usePlaceholder" value="" disabled selected hidden>{{ placeholder }}</option>
		<option v-for="(option, index) in options" :key="`${option[valueKey]}-${index}`" :value="option[valueKey]">
			{{ option[labelKey] }}
		</option>
	</select>
</template>

<script>
export default {
	model: {
		prop: 'value',
		event: 'update',
	},

	props: {
		placeholder: {
			type: String,
			default: '선택해주세요.',
		},
		usePlaceholder: {
			type: Boolean,
			default: true,
		},
		error: Boolean,
		clearable: Boolean,
		options: {
			type: Array,
			default: () => [],
		},
		value: [String, Number],
		justify: Boolean,
		labelKey: {
			type: String,
			default: 'label',
		},
		valueKey: {
			type: String,
			default: 'val',
		},
	},

	data() {
		return {
			hasFocus: false,
			localValue: this.value,
		};
	},

	computed: {
		attrs() {
			return {
				...this.$attrs,
				value: this.localValue,
				maxlength: this.maxlength,
			};
		},
		listeners() {
			return {
				...this.$listeners,
				input: this.onInput,
				focus: this.onFocus,
				blur: this.onBlur,
			};
		},
		input() {
			return this.$refs.inputRef;
		},
		hasValue() {
			return !!this.localValue;
		},
		errorMessage() {
			return typeof this.error === 'string' ? this.error : '';
		},
		length() {
			return this.localValue?.length || 0;
		},
		valueType() {
			if (typeof this.value === 'number') return 'number';
			if (typeof this.options?.[0]?.[this.valueKey] === 'number') return 'number';
			return 'string';
		},
	},

	methods: {
		clear() {
			this.input.focus();
			this.$nextTick(() => {
				this.input.value = '';
				this.localValue = this.valueType === 'number' ? Number(this.input.value) : this.input.value;
			});
		},

		onInput(e) {
			this.localValue = this.valueType === 'number' ? Number(e.target.value) : e.target.value;
			this.$emit('input', e);
		},

		onFocus(e) {
			this.hasFocus = true;
			this.$emit('focus', e);
		},

		onBlur(e) {
			this.hasFocus = false;
			this.$emit('blur', e);
		},

		focus() {
			this.$el?.focus();
		},
	},
	// mounted() {
	// this.localValue = this.$props.value;
	// },
	watch: {
		value() {
			this.localValue = this.value;
		},
		localValue() {
			this.$emit('update', this.localValue);
		},
	},
};
</script>

<style></style>
